import React, { useState, useEffect } from "react";
import {useParams} from 'react-router-dom'
import LoadingBox from "modules/search/components/LoadingBox/LoadingBox";
import { recordDummy } from "modules/search/dummy/record";
import RecordResultHeader from "modules/search/components/RecordResultHeader/RecordResultHeader";
import Recordavailability from "modules/search/components/RecordResultHeader/Recordavailability/Recordavailability";
import RecordInventory from "modules/search/components/RecordResultHeader/RecordInventory/RecordInventory";
import RecordDetail from "modules/search/components/RecordDetail/RecordDetail";
import Axios from 'services/BackendApi/BackendApi';
import { Alert } from "react-bootstrap";

const RecordView = (props) => {
  const [record, setRecord] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [result_header, setResultHeader] = useState({});
  const [selectedLibrary, setSelectedLibrary] = useState("");
  const {id,searchargs,flag} = useParams();
  useEffect(() => {
    console.log(flag)
    setResultHeader(window.location.search)
    // setRecord(recordDummy.record);
    // if (recordDummy?.record?.total_copies > 0) {
    //   setSelectedLibrary(
    //     recordDummy?.record?.inventory[0]?.library ||
    //       recordDummy?.record?.inventory?.library ||
    //       ""
    //   );
    // } // if

    getDocumento();
    return () => {
      setRecord({});
    };
  }, []);

  async function getDocumento() {
    try {
      let res = await Axios.GetDocument({ urlParams: {id} });
      if (res?.data) {
        setRecord(res.data);
      }else{
        setRecord({});
      }
    } catch (error) {
      setRecord({});
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <section className="container">
      {isLoading ? (
        <LoadingBox />
      ) : (
        <React.Fragment>
          <div className="row mt-lg-3 ms-lg-1">
            <div className="col-12">
            {/* <Alert variant="warning" dismissible>
                <Alert.Heading>Información importante</Alert.Heading>
                <p>
                Este documento es parte de la carga inicial del sistema de archivo, si presenta alguna inconsistencia en nombre y contenido favor reportarlo al departamento de archivo,
                <br /> mail <strong>archivo@magdalena.com.gt</strong>.
                </p>
            </Alert> */}
              <RecordResultHeader
                result_header={result_header}
                record={record}
              />
              <div className="row bg-white p-lg-2 mb-2 shadow-sm rounded">
                <RecordDetail record={record} flag={flag} />
              </div>
              <br />
               <RecordInventory
                record={record}
                title={id}
                // setSelectedLibrary={setSelectedLibrary}
                // selectedLibrary={selectedLibrary}
              /> 
            </div>
          </div>
        </React.Fragment>
      )}
    </section>
  );
};

export default RecordView;
